import { Injectable, forwardRef, Inject } from '@angular/core';
import { ApiHandlerService } from '../api-handler/api-handler.service';
import { environment } from '../../../../environments/environment';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { CommonDispatcher } from '../../../store/common/common-dispatcher';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { CustomerDispatcher } from '../../../store/customer/customer-dispatcher';
import { SpinnerService } from '../../../common/components/spinner/overlay-spinner.service';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';
import {
  ApiUserRequestParams,
  ApiPermissionRequestParams,
} from '../../user-role-form/user-role.interface';
import { RequestType, AllowedUserRoleMappings } from '../../user-role-form/user-role.details';
import { UserRoleDispatcher } from '../../../store/user-role/user-role-dispatcher';

type ApiRequestParams = ApiUserRequestParams | ApiPermissionRequestParams;

@Injectable()
export class OrchestrationService {
  /**
   *@var Declaration of spinner Ref
   **/
  public spinnerRef;
  private Dispatcher = {
    userRole: 'setUserRole',
    userRoleUpdate: 'setUserRoleUpdate',
    userPermissions: 'setUserPermissions',
  };
  /**
   * @var This property will set the values when exist in the header
   **/

  constructor(
    @Inject(forwardRef(() => ApiHandlerService))
    public apiHandler: ApiHandlerService,
    public apiDispatcher: ApiResponseDispatcher,
    public commonDispatcher: CommonDispatcher,
    public customerDispatcher: CustomerDispatcher,
    public userRoleDispatcher: UserRoleDispatcher,
    public dialog: MatDialog,
    public router: Router,
    public spinner: SpinnerService,
    public ngRedux: NgRedux<AppState>
  ) { }
  /**
   * set the api response error or success
   **/
  private setResponse(method: string, type: string, body: object) {
    this.spinnerRef.close();
    this.apiDispatcher[method](Object.assign(body, { type }));
  }

  /**
   * set the user role api response
   **/
  private setUserRoleResponse(body: object) {
    this.spinnerRef.close();
    const roleList = !!body && !!body['payload'] && !!body['payload'].roles
      ? body['payload'].roles.filter((r) => AllowedUserRoleMappings.includes(r.roleName))
      : null;
    this.userRoleDispatcher.setUpdateInfo(
      null,
      null,
      roleList
    );
  }
  /**
   * submitUser contains swtich to select right api.
   **/
  submitUser(data: ApiRequestParams): void {
    switch (data.type) {
      case RequestType.getUserRoles:
        this.callGetApi(
          environment.user_roles.apis.get_roles,
          this.Dispatcher.userRole,
          data
        );
        break;
      case RequestType.updateUserRoles:
        this.callPutApi(
          environment.user_roles.apis.update_roles,
          this.Dispatcher.userRoleUpdate,
          data
        );
        break;
      case RequestType.createUserRoles:
        this.callPostApi(
          environment.user_roles.apis.update_roles,
          this.Dispatcher.userRoleUpdate,
          data
        );
        break;
    }
  }

  /**
   * callUserRoleListApi Calls API
   **/
  callUserRoleListApi() {
    const url = environment.user_roles.apis.list_role;
    this.spinnerRef = this.spinner.open();
    this.apiHandler.getRequest(url, null).subscribe({
      next: (response) => this.setUserRoleResponse(response),
      error: (error) => this.setUserRoleResponse(error)
    }
    );
  }

  /**
   * callGetApi Calls API
   **/
  public callGetApi(url: string, dispatcher: string, body: ApiRequestParams) {
    this.spinnerRef = this.spinner.open();
    this.apiDispatcher[dispatcher]({});
    this.apiHandler.getRequest(url, body).subscribe({
      next: (response) => this.setResponse(dispatcher, 'success', response),
      error: (error) => this.setResponse(dispatcher, 'error', error)
    }
    );
  }

  /**
   * callPostApi Calls API
   **/
  public callPutApi(url: string, dispatcher: string, body: ApiRequestParams) {
    this.spinnerRef = this.spinner.open();
    this.apiDispatcher[dispatcher]({});
    this.apiHandler.putRequest(url, body).subscribe({
      next: (response) => this.setResponse(dispatcher, 'success', response),
      error: (error) => this.setResponse(dispatcher, 'error', error)
    }
    );
  }

  /**
 * callPostApi Calls API
 **/
  public callPostApi(url: string, dispatcher: string, body: ApiRequestParams) {
    this.spinnerRef = this.spinner.open();
    this.apiDispatcher[dispatcher]({});
    this.apiHandler.postRequest(url, body).subscribe({
      next: (response) => this.setResponse(dispatcher, 'success', response),
      error: (error) => this.setResponse(dispatcher, 'error', error)
    }
    );
  }


  /**
   * @function deleteUser request to delete the selected user (api call)
   **/
  public deleteUser(email: string): void {
    this.spinnerRef = this.spinner.open();
    this.apiDispatcher['setUserDelete']({});
    const payload = {
      'userEmail': email
    };
    this.apiHandler.deleteRequest(environment.user_roles.apis.update_roles, payload, {

    }).subscribe({
      next: (response) => {
        this.setResponse('setUserDelete', 'success', response);
      },
      error: (error) => {
        this.setResponse('setUserDelete', 'error', error);
      }
    });
  }
}
